import { useEffect, useMemo } from 'react';
import { useInfiniteQuery } from '@tanstack/react-query';

import { LogsFormValues, logsListQuery } from '@/entities/channel';
import { useNotifications } from '@/shared/ui/Notifications';

export function useLogsList(channelId: string, formValues: LogsFormValues) {
  const { addNotification } = useNotifications();
  const {
    data,
    isPending,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useInfiniteQuery({
    ...logsListQuery(channelId ?? '', formValues),
  });

  useEffect(() => {
    if (error) {
      addNotification({
        title: error.data?.details ?? '',
        type: 'error',
      });
    }
  }, [error, addNotification]);

  const allLogs = useMemo(() => {
    return data?.pages.flat() || [];
  }, [data]);

  return {
    logs: allLogs,
    isPending,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  };
}
